enum DisplayOptions {
  FULL_PAGE = 'Banner full page',
  DEALS = 'Banner deals',
  OPL = 'Banner opleidingen',
  QUOTE = 'Banner Quote',
}

// derive constants from type for mainColor
enum MainColor {
  FOREST_GREEN = 'B2B: Forest green',
  DARK_GREEN = 'B2B: Dark green',
  MUTED_BLUE = 'B2B: Muted blue',
  MUTED_RED = 'B2B: Muted red',
  SOFT_GREEN = 'B2B: Soft green',
  LUSH_GREEN = 'B2B: Lush green',
}

enum TextColorOptions {
  WHITE = 'text-white',
  BLACK = 'text-black',
  GREEN = 'text-green',
  GREEN_DARK = 'text-green-dark',
  GREEN_SOFT = 'text-green-soft',
  GREEN_LUSH = 'text-green-lush',
  BLUE_MUTED = 'text-blue-muted',
  BLUE_SILVER = 'text-blue-silver',
  RED = 'text-red',
  RED_SALMON = 'text-red-salmon',
}

enum BackgroundColorOptions {
  GREEN = 'bg-green',
  GREEN_DARK = 'bg-green-dark',
  GREEN_SOFT = 'bg-green-soft',
  GREEN_LUSH = 'bg-green-lush',
  BLUE_SILVER = 'bg-blue-silver',
  BLUE_MUTED = 'bg-blue-muted',
  RED = 'bg-red',
  RED_SALMON = 'bg-red-salmon',
}

type DisplayOptionValue = 'Banner full page' | 'Banner deals' | 'Banner opleidingen' | 'Banner Quote';

export { BackgroundColorOptions, type DisplayOptionValue, DisplayOptions, MainColor, TextColorOptions };
